import request from '../utils/request';
import { getImpersonatedClinicId, withClinicContext } from '../utils/impersonationContext';
const buildOrderUrl = (baseUrl, filters) => {
    const params = new URLSearchParams();
    const impersonatedClinicId = getImpersonatedClinicId();
    if (impersonatedClinicId) {
        params.append('clinic_id', impersonatedClinicId);
    }
    if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
            if (value === undefined || value === null) {
                return;
            }
            if (typeof value === 'string') {
                const normalizedValue = value.trim();
                if (normalizedValue !== '') {
                    params.append(key, normalizedValue);
                }
                return;
            }
            if (String(value).trim() !== '') {
                params.append(key, String(value));
            }
        });
    }
    const queryString = params.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};
export function calculateTax(data) {
    return request().post('/api/v1/calculate-tax/').send(data);
}
export function createOrder(orderData) {
    const url = withClinicContext('/api/v1/orders/');
    return request().post(url).send(orderData);
}
export function confirmStripe3DSPayment(orderId, paymentIntentId) {
    const url = withClinicContext(`/api/v1/orders/${orderId}/confirm-stripe-3ds/`);
    return request().post(url).send({ payment_intent_id: paymentIntentId });
}
export function getOrders(filters) {
    const url = buildOrderUrl('/api/v1/orders/', filters);
    return request().get(url).send();
}
export function getOrder(orderId) {
    const url = withClinicContext(`/api/v1/orders/${orderId}/`);
    return request().get(url).send();
}
export function getShippingMethods(filters = {}) {
    return request().query(filters).get('/api/v1/shipping-methods/').send();
}
export function getOrderInvoice(orderNumber) {
    const url = withClinicContext(`/api/v1/orders/${orderNumber}/invoice/`);
    return request().get(url).send();
}
